import { render, staticRenderFns } from "./WidgetTeam.vue?vue&type=template&id=3564cf0a&scoped=true&"
import script from "./WidgetTeam.vue?vue&type=script&lang=js&"
export * from "./WidgetTeam.vue?vue&type=script&lang=js&"
import style0 from "./WidgetTeam.vue?vue&type=style&index=0&id=3564cf0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3564cf0a",
  null
  
)

export default component.exports